const InactivityModal = ({ showInactivityModal, setShowInactivityModal, disconnectConversation, arisDisconnected, navigate }) => {
  if (!showInactivityModal) return null;
  
  return (
    <div className="inactivity-modal">
      <div className="inactivity-modal-content">
        <h2>Seems like you are away</h2>
        <p>Would you like to continue?</p>
        <div className="inactivity-modal-buttons">
          <button onClick={() => setShowInactivityModal(false)}>Continue</button>
          <button
            onClick={() => {
              if (!arisDisconnected) {
                disconnectConversation(false, true, 'dashboard');
              } else {
                window.location.href = '/dashboard';
              }
            }}
          >
            End Session
          </button>
        </div>
      </div>
    </div>
  );
};

export default InactivityModal;